document.querySelector("html").classList.remove("no-js");

// Checks
const body = document.querySelector("body");
const indexCheck = document
  .querySelector("body")
  .classList.contains("template-index");
const productCheck = document
  .querySelector("body")
  .classList.contains("template-product");
const formCheck = document.getElementById("add-to-cart-form") !== null;
const qtyCheck = document.querySelector(".js-quantity-picker") !== null;
const lineQtyCheck = document.querySelector("quantity-selector") !== null;
const instaCheck = document.querySelector(".main-instagram") !== null;
const gridSectionCheck = document.querySelector(".grid-slider") !== null;
const collectionCheck = document.querySelector(".collection-grid") !== null;

// Widths
const px900 = window.innerWidth <= 900;

// Reccs

function reccs() {
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        console.log("load reccs");
        const html = document.createElement("section");
        html.innerHTML = text;
        const recommendations = html.querySelector(".product-recommendations");
        console.log("reccomendations");

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector(
    ".product-recommendations"
  );
  const observer = new IntersectionObserver(handleIntersection, {
    rootMargin: "0px 0px 200px 0px",
  });

  observer.observe(productRecommendationsSection);
}
// if (productCheck) {
//     reccs()
// }

function intObs() {
  let observerSelector = ".observed",
    observerObject = document.querySelectorAll(observerSelector),
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio >= 0.1) {
            entry.target.classList.add("in-view");
          } else {
            entry.target.classList.remove("in-view");
          }
        });
      },
      {
        threshold: [0, 0.1, 1],
      }
    );

  observerObject.forEach((holder) => {
    observer.observe(holder);
  });

  window.addEventListener("resize", function () {
    observerObject.forEach((holder) => {
      observer.observe(holder);
    });
  });
}

// intObs();

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", function () {
    intObs();
  });
}

class MiniCart {
  constructor(target) {
    target.addEventListener("click", this.onMiniCartClick.bind(this));
  }

  onMiniCartClick(event) {
    event.preventDefault();

    let htmlEl = document.querySelector("html"),
      menuBrowseCheck = htmlEl.classList.contains("browse-menu-active"),
      menuInfoCheck = htmlEl.classList.contains("info-menu-active"),
      cartCheck = htmlEl.classList.contains("mini-cart-open");

    // htmlEl.classList.toggle('mini-cart-open')

    if (!cartCheck) {
      htmlEl.classList.add("mini-cart-open");
      event.target.setAttribute("aria-expanded", "true");

      if (menuBrowseCheck || menuInfoCheck) {
        console.log("menu active");
        htmlEl.classList.remove("browse-menu-active", "info-menu-active");
      }
    } else {
      htmlEl.classList.remove("mini-cart-open");
      event.target.setAttribute("aria-expanded", "false");
    }
  }
}

const miniCartLinks = document.querySelectorAll(".js-cart-link");

miniCartLinks.forEach((link) => {
  new MiniCart(link);
});

class MobileMenu {
  constructor(target) {
    target.addEventListener("click", this.onMenuClick.bind(this));
  }

  onMenuClick(event) {
    event.preventDefault();
    // console.log('menu click')

    const mobileNav = document.getElementById("mobile-menu");

    let htmlEl = document.querySelector("html"),
      menuCheck = htmlEl.classList.contains("menu-active"),
      cartCheck = htmlEl.classList.contains("mini-cart-open");

    if (!menuCheck) {
      if (cartCheck) {
        htmlEl.classList.remove("mini-cart-open");
      }

      // event.target.textContent = 'Close'
      htmlEl.classList.add("menu-active");
      event.target.setAttribute("aria-expanded", "true");
      mobileNav.setAttribute("aria-expanded", "true");
    } else {
      // event.target.textContent = 'Menu'
      htmlEl.classList.remove("menu-active");
      event.target.setAttribute("aria-expanded", "false");
      mobileNav.setAttribute("aria-expanded", "false");
    }
  }
}

const menuLinks = document.querySelectorAll(".js-menu-link");

menuLinks.forEach((link) => {
  new MobileMenu(link);
});

class Accordian extends HTMLElement {
  constructor() {
    super();
    this.title = this.querySelector(".acc-title").addEventListener(
      "click",
      this.onTitleClick.bind(this)
    );
    this.content = this.querySelector(".acc-content");
  }

  onTitleClick(event) {
    event.preventDefault();
    console.log("click title");
    this.setAttribute('aria-expanded', true)
    this.querySelector('.acc-title').setAttribute('aria-expanded', true)
    this.classList.toggle("acc-active");
  }
}

customElements.define("custom-accordian", Accordian);

function mobileSubMenu(wrap, title, links) {
  title.addEventListener("click", function (e) {
    e.preventDefault();

    let thisLinkTitle = this.dataset.title,
      status = this.querySelector(".menu-status");

    console.log(thisLinkTitle);

    status.classList.toggle("active");
    wrap.classList.toggle("active");
  });
}

// Main Menu
if (px900) {
  
  let hiddenLinks = document.querySelectorAll("li.meganav-link"),
    navTitles = document.querySelectorAll(".mobile-list ul li.title a"),
    hiddenSearch = document.querySelector(".mobile-drawer-wrap.search li.search"),
    searchTitle = document.querySelector(
      ".mobile-drawer-wrap.search li.search-title a"
    ),
    searchWrap = document.querySelector(".mobile-drawer-wrap.search ul");

  navTitles.forEach((title) => {
    let wrap = title.closest("ul.meganav-linklist"),
      links = wrap.querySelectorAll("li.meganav-link");

    mobileSubMenu(wrap, title, links);
  });

  // mobileSubMenu(searchWrap, searchTitle, hiddenSearch);

}
const browseLink = document.querySelectorAll(".js-browse-link");
const infoLink = document.querySelectorAll(".js-info-link");
const menuLink = document.querySelectorAll(".js-menu-link");

function mainMenu(link, other, active) {
  link.forEach((e) => {
    function classes() {
      let html = document.querySelector("html"),
        otherClass = other + "-menu-active",
        cartActive = "mini-cart-open",
        searchActive = "search-menu-active";

      if (html.classList.contains(cartActive)) {
        // console.log("remove " + cartActive);
        html.classList.remove(cartActive);
      }
      if (html.classList.contains(searchActive)) {
        // console.log("remove " + cartActive);
        html.classList.remove(searchActive);
      }
      if (html.classList.contains(otherClass)) {
        //   console.log("remove " + otherClass);
        html.classList.remove(otherClass);
      }

      html.classList.toggle(active);
    }

    e.addEventListener("click", function (e) {
      e.preventDefault();
      classes();
    });

    // e.addEventListener("mouseenter", function (e) {
    //   classes();
    // });
  });
}

mainMenu(browseLink, "info", "browse-menu-active");
mainMenu(infoLink, "browse", "info-menu-active");

function closeMenu() {
  if (!px900) {
    let html = document.querySelector("html"),
      info = document.getElementById("shopify-section-main-navigation-info"),
      browse = document.getElementById("browse"),
      search = document.getElementById("search"),
      header = document.querySelector("header"),
      miniCart = document.getElementById("mini-cart"),
      banner = document.getElementById("ann-bar");

    window.addEventListener("click", function (e) {
      if (html.classList.length > 0) {
        if (header.contains(e.target)) {
          // console.log('click in header')
        } else if (info.contains(e.target)) {
          // console.log('click in info')
        } else if (browse.contains(e.target)) {
          // console.log('click in browse')
        } else if (search.contains(e.target)) {
          // console.log('click in search')
        } else if (miniCart.contains(e.target)) {
          // console.log('click in cart')
        } else if (banner.contains(e.target)) {
          // console.log('click in bar')
        } else {
          console.log("click to close menu");
          html.className = "";
        }
      }
    });
  }
}

closeMenu();

class SearchMenu {
  constructor(target) {
    target.addEventListener("click", this.onSearchClick.bind(this));
    // target.addEventListener("mouseenter", this.onSearchOver.bind(this));
  }

  onSearchClick(event) {
    event.preventDefault();

    console.log("search click");

    let html = document.querySelector("html"),
      browseMenu = "browse-menu-active",
      infoMenu = "info-menu-active",
      cartActive = "mini-cart-open";

    if (html.classList.contains(cartActive)) {
      html.classList.remove(cartActive);
    } else if (html.classList.contains(browseMenu)) {
      html.classList.remove(browseMenu);
    } else if (html.classList.contains(infoMenu)) {
      html.classList.remove(infoMenu);
    }

    html.classList.toggle("search-menu-active");
  }

  // onSearchOver(event) {
  //   event.preventDefault();

  //   console.log("search over");

  //   let html = document.querySelector("html"),
  //     browseMenu = "browse-menu-active",
  //     infoMenu = "info-menu-active",
  //     cartActive = "mini-cart-open";

  //   if (html.classList.contains(cartActive)) {
  //     html.classList.remove(cartActive);
  //   } else if (html.classList.contains(browseMenu)) {
  //     html.classList.remove(browseMenu);
  //   } else if (html.classList.contains(infoMenu)) {
  //     html.classList.remove(infoMenu);
  //   }

  //   html.classList.toggle("search-menu-active");
  // }
}

let searchLinks = document.querySelectorAll(".js-search-link");

searchLinks.forEach((link) => {
  new SearchMenu(link);
});

class SearchForm {
  constructor(target) {
    target.addEventListener("keyup", this.onSearchInputKeyUp.bind(this));
  }

  onSearchInputKeyUp(event) {
    let form = event.target.closest("form"),
      button = form.querySelector(".js-search-submit"),
      shouldDisableButton = event.target.value.length === 0;

    console.log(shouldDisableButton);

    if (shouldDisableButton) {
      button.setAttribute("disabled");
      button.classList.add("btn-disabled");
    } else {
      button.classList.remove("btn-disabled");
      button.removeAttribute("disabled");
    }
  }
}

let searchInput = document.querySelectorAll(".js-search-input");

searchInput.forEach((search) => {
  new SearchForm(search);
});

// SLIDERS


// Ann. Bar

function annBar() {
  let annBar = document.querySelector('.announcement-bar'),
      annClose = document.querySelector('.announcement-bar .js-close'),
      slider = document.querySelector('.announcement-slider'),
      html = document.querySelector('html'),
      bannerCheck = html.classList.contains('show-banner')
    
  if (sessionStorage.hasOwnProperty("annHide")) {
      console.log('banner hidden');
      html.classList.remove('show-banner')
      annBar.style.display = 'none'
      annBar.setAttribute('hidden', true)

      html.style.setProperty('--ann-bar-height', '0px');
  } else {

    html.style.setProperty('--ann-bar-height', '2rem'); 
    if (bannerCheck) { 
      // html.classList.add('show-banner')
      console.log('banner already showing');
      
    
      if (slider) {
        var annFlkty = new Flickity(slider,
        {
          wrapAround: true,
          prevNextButtons: false,
          cellSelector: '.ann-cell',
          autoPlay: 4000,
          pageDots: false,
          setGallerySize: false 
        })
      }
    
      annClose.addEventListener('click', function(event) {
        event.preventDefault()
        html.style.setProperty('--ann-bar-height', '0px');
        html.classList.remove('show-banner')
        annBar.style.display = 'none'
        annBar.setAttribute('hidden', true)

        window.sessionStorage.setItem("annHide", "true");
        window.sessionStorage.setItem("origin", "https://true-grace-wholesale.myshopify.com");
      })

   
    }
  }
}

annBar()







function gridSlider(slider, container) {
  if (!px900) {
    var gridFlkty = new Flickity(slider, {
      prevNextButtons: false,
      draggable: false,
      adaptiveHeight: true,
      pageDots: false,
      on: {
        change: function (index) {
          let newIndex = index + 1,
            slideId = "slide-" + newIndex,
            currentSlide = container.querySelector("#" + slideId),
            currentHash = container.querySelector(
              '[data-selector="#' + slideId + '"]'
            ),
            hashLinks = container.querySelectorAll(".hash-list .button");
          console.log("slide-" + newIndex);

          hashLinks.forEach((link) => {
            if (link.classList.contains("active-slide")) {
              link.classList.remove("active-slide");
            }
          });
          console.log('[data-selector="#' + slideId + '"]');
          container
            .querySelector('[data-selector="#' + slideId + '"]')
            .classList.add("active-slide");
        },
      },
    });
  } else {
    var gridFlkty = new Flickity(slider, {
      prevNextButtons: false,
      draggable: true,
      pageDots: false,
      on: {
        change: function (index) {
          let newIndex = index + 1,
            slideId = "slide-" + newIndex,
            currentSlide = container.querySelector("#" + slideId),
            currentHash = container.querySelector(
              '[data-selector="#' + slideId + '"]'
            ),
            hashLinks = container.querySelectorAll(".hash-list .button");

          console.log("slide-" + newIndex);

          hashLinks.forEach((link) => {
            if (link.classList.contains("active-slide")) {
              link.classList.remove("active-slide");
            }
          });
          container
            .querySelector('[data-selector="#' + slideId + '"]')
            .classList.add("active-slide");
        },
      },
    });
  }

  let hashList = container.querySelector(".hash-list");

  hashList.addEventListener("click", function (event) {
    if (!matchesSelector(event.target, ".button")) {
      return;
    }
    var selector = event.target.dataset.selector;
    gridFlkty.selectCell(selector);
  });
}

let gridInner = document.querySelectorAll(".grid-slider"),
    pageGridInner = document.querySelectorAll(".page-grid-slider")

if (gridSectionCheck) {
  gridInner.forEach((grid) => {
    let container = grid.parentNode;
    gridSlider(grid, container);
  });
}

if (pageGridInner !== null) { 
  pageGridInner.forEach((grid) => {
    let container = grid.parentNode;
    gridSlider(grid, container);
  });
}

function promoSlider(slider) {
  new Flickity(slider, {
    prevNextButtons: false,
    draggable: true,
  });
}

let promoSlides = document.querySelector(".product-bar-inner.slider");

if (promoSlides !== null) {
  promoSlider(promoSlides);
}

function typeSlider(slider) {
  if (px900) {
    new Flickity(slider, {
      prevNextButtons: false,
      draggable: true,
      pageDots: true,
      groupCells: 3,
      adaptiveHeight: true,
      cellAlign: "left",
      autoPlay: true,
    });
  } else {
    new Flickity(slider, {
      prevNextButtons: false,
      draggable: true,
      pageDots: true,
      groupCells: 4,
      adaptiveHeight: true,
      cellAlign: "left",
      autoPlay: true,
    });
  }
}

let iconSlider = document.querySelector(".icon-slider");

if (iconSlider !== null) {
  typeSlider(iconSlider);
}

function productGallery(slider) {
  new Flickity(slider, {
    prevNextButtons: false,
    draggable: true,
    pageDots: false,
    cellSelector: ".gallery-media",
  });
}

let productGallerySlider = document.querySelector(".product-gallery");

if (px900 && productCheck) {
  productGallery(productGallerySlider);
}

// Filter Fixer

/* Feature detection */
let passiveIfSupported = false;

try {
  window.addEventListener(
    "test",
    null,
    Object.defineProperty({}, "passive", {
      get() {
        passiveIfSupported = { passive: true };
      },
    })
  );
} catch (err) {}

function fixFilter() {
  window.addEventListener(
    "scroll",
    (event) => {
      let collectionGrid = document.querySelector(".collection-grid"),
        collectionFilter = collectionGrid.querySelector(".collection-filter"),
        collectionSort = collectionGrid.querySelector(".facets-vertical-sort"),
        distanceToGrid = collectionGrid.offsetTop,
        distanceToGridMargin = distanceToGrid - 48,
        pixelPosition = window.scrollY;

      if (pixelPosition >= distanceToGridMargin) {
        // console.log('add class now')
        collectionFilter.classList.add("scroll");
        collectionSort.classList.add("scroll");
      } else {
        // console.log('remove class now')
        collectionFilter.classList.remove("scroll");
        collectionSort.classList.remove("scroll");
      }
    },
    passiveIfSupported
  );
}

if (collectionCheck) {
  fixFilter();
}


function fixMobileForm() {
  if (px900 && productCheck) {

    let productMainWrap = document.querySelector(".product-main-wrap"),
        addToCartForms = productMainWrap.querySelectorAll(".add-to-cart-form"),
        observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.intersectionRatio >= 0.1) {
              entry.target.classList.add("scroll");
              console.log('add class')
            } 
          });
        },  
        {
          threshold: [0, 0.1, 1],
        }
      );

    addToCartForms.forEach((form) => {
      observer.observe(form);
    });

  window.addEventListener("resize", function () {
    addToCartForms.forEach((form) => {
      observer.observe(form);
    });
  });
  }
}

fixMobileForm()


function onFacetClick(facet) {
  facet.addEventListener("click", function (event) {
    let dataOpen = event.target.closest("details[open]"),
      openCheck = facet.classList.contains("svg-open");

    // console.log(openCheck);

    if (openCheck) {
      // console.log("close");
      this.classList.remove("svg-open");
    } else {
      // console.log("open");
      this.classList.add("svg-open");
    }
  });
}


MicroModal.init({
  onShow: modal => console.info(`${modal.id} is shown`), // [1]
  onClose: modal => console.info(`${modal.id} is hidden`), // [2]
  openClass: 'is-open', 
  disableScroll: true, 
  disableFocus: false, 
  awaitOpenAnimation: false, 
  awaitCloseAnimation: false
});
        








let details = document.querySelectorAll("summary");

details.forEach((detail) => {
  onFacetClick(detail);
});

let prGrid = document.querySelector(".product-grid");

function infScroll(container) {
  let pagination = document.querySelector(".pagination");

  if (pagination !== null) {
    document
      .querySelector(".view-more-button")
      .addEventListener("click", function (e) {
        e.preventDefault();
      });

    new InfiniteScroll(container, {
      // options
      hideNav: ".pagination",
      button: ".view-more-button",
      scrollThreshold: false,
      path: ".pagination-step.next",
      append: ".product-card",
      history: true,
      historyTitle: true,
    });
  }
}

infScroll(prGrid);

function collectionScripts() {
  console.log("reset collection scripts");

  let details = document.querySelectorAll("summary"),
    miniCartLinks = document.querySelectorAll(".js-cart-link");
    miniCartLinks.forEach((link) => {
      new MiniCart(link);
    });
  intObs();
  infScroll(prGrid);


  details.forEach((detail) => {
    onFacetClick(detail);
  });

  fixFilter();
}
